//
//
//
//
//
//

export default {
	name: "CaroFilterLocation",
	props: {
		filters: Array,
		results: Object,
		setFilterValue: Function,
		executeSearch: Function,
		extend: Function,
		extended: Object
	},
	data() {
		return {};
	},
	computed: {
		model: {
			get() {
				return this.extended?.location;
			},
			set(value) {
				this.extend(extended => {
					extended.location = value;
					return extended;
				})
			},
		},
    },
    methods: {
        disallowLetters(evt){
            const acceptedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Alt', 'Control', 'Meta', 'Backspace', 'Delete', 'End', 'Home']
            if (!(acceptedKeys.includes(evt.key) || evt.key.includes('Arrow'))) {
                evt.preventDefault()
            }
    	}
    }
};
